import { LoginUser } from "../type/login-user";

import { initialState } from "../../../context/auth";
import { KB, GB } from "../../../constants/size";

/**
 * 取込モード (is_new_db) をビルド時に決め打ちするための環境変数。
 *
 * - `REACT_APP_IS_NEW_DB_FORCE` … 設定されていれば API の値を無視して強制する
 *   ("true" なら新 DB、それ以外の値なら legacy)。ローカルでの動作確認用。
 * - `REACT_APP_IS_NEW_DB` … API が値を返さないときだけ使うフォールバック。
 *
 * どちらも未設定なら API の値 (無ければ false) に従う。
 */
function resolveIsNewDb(apiValue: boolean | string | null | undefined): boolean {
  const force = process.env.REACT_APP_IS_NEW_DB_FORCE;
  if (force) return force === "true";
  if (apiValue === true || apiValue === "1") return true;
  if (apiValue === false || apiValue === "0") return false;
  return process.env.REACT_APP_IS_NEW_DB === "true";
}

function resolvePlatformUrl(clientData: any): string | null {
  if (clientData.platform_url !== null) {
    return clientData.platform_url;
  }
  const is_new_db = resolveIsNewDb(clientData.is_new_db);
  if (is_new_db) {
    return process.env.REACT_APP_XCAUSAL_NEW_DB_PLATFORM_URL || null;
  } else {
    return process.env.REACT_APP_XCAUSAL_PLATFORM_URL || null;
  }
}

export class LoginUserAdapter {
  static toOutputDTO({
    clientData,
    userData,
  }: {
    clientData: any;
    userData: any;
  }): LoginUser {
    if (!userData.data || userData.data.length === 0) {
      return initialState as LoginUser;
    }

    const data = userData.data.find(
      (user: any) => user.user_id === userData.user_id
    );

    return {
      id: data?.user_id ?? null,
      name: data?.name ?? null,
      role: data?.status ?? 0,
      email: data?.email ?? null,
      client: {
        id: clientData.vendor_id ?? null,
        name: clientData.vendor_name ?? null,
        logo: clientData.image_url ?? null,
        used_size: clientData.used_capacity ?? null,
        used_code: clientData.used_code ?? null,
        role_requests: 
          clientData.role_requests?.map((r: any) => ({
            id: r.user_id,
            name: r.name,
            email: r.email,
          })) || [],
          is_waiting_review: clientData.is_waiting_review ?? false,
          is_approved_review: clientData.is_approved_review ?? false,
          is_use_assistant: clientData.is_use_assistant ?? false,
          is_new_db: resolveIsNewDb(clientData.is_new_db),
          platform_url: resolvePlatformUrl(clientData),
      },
      plan: {
        plan_id: clientData.plan_id,
        plan_type: clientData.plan_type,
        is_plan_active: clientData.enable_pu,
        is_mobile_link: !clientData.is_noapps,
        is_multi_project: clientData.is_multi ?? false,
        fee_type: clientData.fee_type,
        pay_type: clientData.is_bill ? "bank" : "card",
        limit_size: clientData.is_bill
          ? clientData.fee_type === "capacity"
            ? clientData.bill_code_num * GB
            : null
          : clientData.data_capacity == 0
            ? null
            : clientData.data_capacity * KB,
        node_size: clientData.dataethno_node ?? 10,
      },
      projects:
        clientData.projects?.map((p: any) => ({
          id: p.vendor_id,
          key: p.project_name,
          value: p.vendor_id === clientData.vendor_id,
          meta: { name: p.vendor_name },
        })) || [],
      trial: {
        status: userData.trial_status ?? null,
        expire: userData.trial_expire_date
          ? new Date(userData.trial_expire_date * 1000)
          : 0,
        unix: userData.trial_expire_date,
      },
    } as LoginUser;
  }
}
